import DevToolsCard from "./DevToolsCard";
import { Grid2 } from "@mui/material";
import styles from "./DevToolsGrid.module.scss";
import Gcplogo from "../../../../../../GlobalAssets/PNG/Gcplogo.png";
import AwsCloudFrontLogo from "../../../../../../GlobalAssets/svg/AwsCloudFront.svg";

export default function DevToolsGrid({
  debug,
  cache,
  waf,
  // EBS (v2) site: WAF is always on and the CDN is AWS CloudFront
  ebsSite,
  wafUpdating,
  cdnFunc,
  openSsh,
  wafClick,
  cacheClick,
  debugClick,
  dedicatedHosting,
}) {
  const devToolsData = [
    {
      title: "Wp_Debug",
      subTitle: "Turn on debug mode in Wordpress",
      status: debug,
      click: debugClick,
    },
    {
      title: "Wp_Cache",
      subTitle:
        "Turn on WP_Cache to allow approved caching plugins to build and control",
      status: cache,
      click: cacheClick,
    },
    {
      title: "WAF",
      subTitle: ebsSite
        ? "Web Application Firewall (WAF) is enabled for this site, adding a layer of protection against cyber threats and unauthorized access."
        : "Turn on Web Application Firewall (WAF) to provide an additional layer of protection against potential cyber threats and unauthorized access.",
      status: ebsSite ? true : waf,
      // WAF on/off toggle removed — keep the WAF card visible but render no switch.
      hideToggle: true,
      ...((dedicatedHosting || ebsSite) && { customText: "Enabled" }),
    },
    {
      title: "CDN",
      subTitle: ebsSite
        ? "Cache Invalidation for all the cache in AWS CloudFront"
        : "Cache Invalidation for all the cache in GCP CDN",
      button: "Cache Invalidation",
      buttonFunc: cdnFunc,
      imageSrc: ebsSite ? AwsCloudFrontLogo : Gcplogo,
    },
    // {
    //   title: "SSH",
    //   subTitle: "Cache Invalidation for all the cache in GCP CDN",
    //   button: "Open SSH",
    //   buttonFunc: openSsh,
    // },

    // {
    //   title: "CDN powered by",
    //   subTitle:
    //     "The Content Delivery Network speeds up page loads for your site’s visitors. You’re experiencing the best of the best with Fastly. Sit back and enjoy the speed!",
    //   src: Gcplogo,
    // },
  ];

  return (
    <Grid2>
      <Grid2 container spacing={2} className={styles.gridContainer}>
        {devToolsData
          .filter((item) => {
            // Hide Wp_Debug and Wp_Cache when dedicatedHosting is true
            if (
              dedicatedHosting &&
              (item.title === "Wp_Debug" || item.title === "Wp_Cache")
            ) {
              return false;
            }
            return true;
          })
          .map((item, index) => (
            <Grid2 item key={index} className={styles.gridItem}>
              <DevToolsCard
                title={item.title}
                subTitle={item.subTitle}
                src={item.src}
                status={item.status}
                onChange={item.click}
                button={item.button}
                onClick={item.buttonFunc}
                imageSrc={item.imageSrc}
                customText={item.customText}
                loading={item.loading}
                hideToggle={item.hideToggle}
              />
            </Grid2>
          ))}
      </Grid2>
    </Grid2>
  );
}
